import * as React from 'react'
import { FC, useMemo } from 'react'
import { IProviderProps } from '@user/components/Filters'
import { useGetAllFunnelStagesForFilters } from '@user/store/salesFunnel/hooks'
import { stagesToIOptions } from '@user/store/salesFunnel/mapper'
import { useSelectFunnelStagesByTypes } from '@user/store/salesFunnel/hooks/useSelectFunnelStagesByTypes'
import { optionDependencyToArray } from '@user/components/Filters/typings/IOption'

export const SalesFunnelStageProvider: FC<IProviderProps> = ({
  render,
  dependsOn,
}) => {
  const { isFetching: loading } = useGetAllFunnelStagesForFilters()

  const funnelIds = useMemo(
    () => optionDependencyToArray(dependsOn),
    [dependsOn],
  )

  const enableGroup = funnelIds === undefined

  const stages = useSelectFunnelStagesByTypes(
    funnelIds.map((x) => Number(x.value)),
    'Lead',
  )

  const options = useMemo(() => stagesToIOptions(stages), [stages])
  options.sort((a, b) => a.label.localeCompare(b.label))

  return <>{render(options, loading, enableGroup)}</>
}
SalesFunnelStageProvider.displayName = 'SalesFunnelStageProvider'
